import apiClient from "../../axios/apiClient";


export const getRoleList =
  (token, limit = 10, page = 1, search = "", sort = "desc",status) =>
  async (dispatch) => {
    try {
      dispatch({ type: "GET_ROLELIST_PENDING" });

      const response = await apiClient.get(
        `/api/v1/role`,
        {
          params: {
            limit: limit,
            page: page,
            search: search,
            sort: sort,
            status,
          },
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      dispatch({
        type: "GET_ROLELIST_FULFILLED",
        payload: response.data?.data,
        roleCount: response.data?.count,
        permissions: response.data?.permissions,
      });
    } catch (error) {
      dispatch({
        type: "GET_ROLELIST_REJECTED",
        payload: error.response,
      });
    }
  };




  export const getRoleListById =(token,id) =>
  async (dispatch) => {
    try {
      dispatch({ type: "GET_ROLELISTBYID_PENDING" });

      const response = await apiClient.get(
        `/api/v1/role/${id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      dispatch({
        type: "GET_ROLELISTBYID_FULFILLED",
        payload: response.data?.data,
        roleCount: response.data?.count,
      });
    } catch (error) {
      dispatch({
        type: "GET_ROLELISTBYID_REJECTED",
        payload: error.response,
      });
    }
  };


export const updateRoleData = (token, data, id) => async (dispatch) => {
  try {
    dispatch({ type: "UPDATE_ROLE_PENDING" });

    const response = await apiClient.put(
      `/api/v1/role/${id}`, // Endpoint URL with vehicle ID
      data, // Data payload
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    dispatch({ type: "UPDATE_ROLE_FULFILLED", payload: response.data });
  } catch (error) {
    dispatch({ type: "UPDATE_ROLE_REJECTED", payload: error.response });
  }
};

export const saveRoleData = (token, data) => async (dispatch) => {
    try {
      dispatch({ type: "ADD_ROLE_PENDING" });
  
      const response = await apiClient.post(
        `/api/v1/role`,
        data, // Data payload should be the second argument
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      dispatch({ type: "ADD_ROLE_FULFILLED", payload: response.data });
    } catch (error) {
      dispatch({ type: "ADD_ROLE_REJECTED", payload: error.response });
    }
  };
  


export const deleteRoleData = (token, id) => async (dispatch) => {
  try {
    dispatch({ type: "DELETE_ROLE_PENDING" });

    const response = await apiClient.delete(
      `/api/v1/role/${id}`, // Endpoint URL with vehicle ID
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    dispatch({ type: "DELETE_USER_FULFILLED", payload: response.data });
  } catch (error) {
    dispatch({ type: "DELETE_USER_REJECTED", payload: error.response });
  }
};



